module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step5_Image8.97131562.jpg";